import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Lanternfish from '../../components/Lanternfish/Lanternfish';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardLanternfish extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Lanternfish/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Prevalent World-wide"
   diagnosis="The lanternfish, also known as Symbolophorus barnardi, is a deep-water fish that gets its name from its ability to produce light. They make up 65% of the deep sea biomass. Plastic ingestion is threatening future stocks."
   prediction="Aquatic mammals, sea birds, and fish at higher tropic levels depend on lanternfish as a source of food (Science Direct)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardLanternfish;
